import type { ReactNode } from "react";

import { AppSidebar } from "@/components/layout/app-sidebar";
import { ImpersonationBanner } from "@/components/layout/impersonation-banner";
import { useMe } from "@/lib/hooks/useMe";

export function ProtectedShell({ isStaging, children }: { isStaging: boolean; children: ReactNode }) {
    const me = useMe();
    const impersonando = me.impersonation !== null;

    // Empilha os banners fixos: staging (top-0) primeiro, impersonação abaixo dele quando ambos ativos
    const bannersHeight = (isStaging ? 1 : 0) + (impersonando ? 1 : 0);
    const offsetClass = bannersHeight === 2 ? "top-24" : bannersHeight === 1 ? "top-12" : "";

    return (
        <>
            {impersonando && (
                <ImpersonationBanner
                    targetNome={me.nome ?? me.email}
                    targetEmail={me.email}
                    topClassName={isStaging ? "top-12" : "top-0"}
                />
            )}
            <div className={`fixed inset-0 flex overflow-hidden bg-canvas text-label ${offsetClass}`}>
                <AppSidebar />
                <main className="min-h-0 flex-1 overflow-auto">
                    <div className="flex flex-col gap-4.5 px-8 pb-6 pt-8 pl-5">{children}</div>
                </main>
            </div>
        </>
    );
}
